import React from 'react';
import style from './style.module.scss';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {Price} from './Price';
import {Information} from './Information';

type TProductSnippetContentProps = Pick<IProductSnippet, 'title' | 'description' | 'properties' | 'url'> & {
    badges: IProductSnippet['price']['badges'];
    pixelOverflow: number;
} & Pick<IProductSnippet['price'], 'cashback' | 'old' | 'current' | 'currency' | 'unit' | 'percent'> &
    Pick<IProductSnippet['analytics'], 'onProductClick'>;

export const ProductSnippetContent = (props: TProductSnippetContentProps) => {
    const {
        title,
        description,
        badges,
        pixelOverflow,
        cashback,
        old,
        current,
        currency,
        unit,
        percent,
        properties,
        onProductClick,
        url,
    } = props;

    return (
        <div className={style.contentContainer}>
            <Information
                title={title}
                description={description}
                badges={badges}
                pixelOverflow={pixelOverflow}
                properties={properties}
                onProductClick={onProductClick}
                url={url}
            />
            <Price
                cashback={cashback}
                old={old}
                current={current}
                currency={currency}
                unit={unit}
                badges={badges}
                percent={percent}
            />
        </div>
    );
};
